const { BUSINESS_MODELS, CEE_SUBSIDY_TYPES } = require("../../constants");

const getCEESubsidy = (journeyType, appConfig, businessModel, type) => {
  const { configuration } = appConfig;

  const ceeSubsidy =
    businessModel === BUSINESS_MODELS.B2B
      ? configuration.app.solJourney.b2b[journeyType]?.ceeSubsidy
      : configuration.app.solJourney[journeyType]?.ceeSubsidy;

  if (ceeSubsidy && ceeSubsidy[type]) {
    return {
      ...ceeSubsidy[type],
      type,
    };
  }

  return undefined;
};

module.exports = { getCEESubsidy };
